// extracted by mini-css-extract-plugin
export default {"colorOrange":"#ff6332","timeSlotsContainer":"timeSlotsContainer__1nmbC","label":"label__3476_","row":"row__Zd6dD","timeSlotsLegend":"timeSlotsLegend__2novV","timeSlotsColor":"timeSlotsColor__mN5WL","timeSlotsLegendCaption":"timeSlotsLegendCaption__2ZEQs","timeSlotsBooked":"timeSlotsBooked__2k95l","timeSlotsAvailable":"timeSlotsAvailable__3W5_p"};
    if(module.hot) {
      // 1788784384842
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  